import axios from "axios";
import { useQuery } from "@tanstack/vue-query";
import { endpoints } from "@/endpoints";
import { tags } from "@/api/common";
import useApiStore from "@/stores/api";
import { useLocationSelector } from "@/composables/location";

import { StatusType, type StatusesResponse, type Status } from "@/api/statuses";

export const useGetStatuses = (onSuccess: (data: Status[]) => void) => {
  const apiStore = useApiStore();
  const { selectedLocationGroupPk, isLocationsLoaded } = useLocationSelector();
  return useQuery({
    queryKey: [
      tags.platform.statuses,
      { locationGroupPk: selectedLocationGroupPk },
    ],
    queryFn: async () => {
      const result = await axios.get<StatusesResponse>(
        apiStore.getEndpoint("platform", endpoints.statuses.list),
        {
          params: {
            locationGroupPk: selectedLocationGroupPk.value,
          },
        }
      );
      return result.data.statuses
        .map(
          (status) =>
            ({
              ...status,
              enabled: Boolean(Number(status.enabled)),
              order: Number(status.order),
              item_id: Number(status.item_id),
            }) as Status
        )
        .filter(({ type }) => type === StatusType.company);
    },
    enabled: isLocationsLoaded,
    onSuccess: onSuccess,
  });
};
